import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutocompleteComponent } from './components/autocomplete/autocomplete.component';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { IconModule } from '../icon/icon.module';
import { TooltipModule } from '../tooltip/tooltip.module';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { ButtonLegacyModule } from '../button-legacy/button-legacy.module';
import { CheckboxModule } from '../checkbox/checkbox.module';
import { HighlightPipe } from './pipes/highlight.pipe';

@NgModule({
  declarations: [AutocompleteComponent, HighlightPipe],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TooltipModule,
    IconModule,
    ButtonLegacyModule,
    CheckboxModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatInputModule,
    MatChipsModule,
  ],
  providers: [HighlightPipe],
  exports: [AutocompleteComponent],
})
export class AutocompleteModule {}
